import { useEffect } from 'react';

/**
 * Reset route - Clears all app data from localStorage and redirects to home
 *
 * This route:
 * 1. Clears all yomidi-* localStorage keys
 * 2. Performs a hard redirect to the homepage
 * 3. Effectively resets the app to its initial state
 */
export default function Reset() {
  useEffect(() => {
    console.log('[RESET] Clearing all app data from localStorage...');

    // Get all localStorage keys that start with 'yomidi-'
    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith('yomidi-')) {
        keysToRemove.push(key);
      }
    }

    // Also clear cookie consent
    keysToRemove.push('cookie-consent');

    // Remove all identified keys
    keysToRemove.forEach(key => {
      console.log(`[RESET] Removing: ${key}`);
      localStorage.removeItem(key);
    });

    console.log(`[RESET] Cleared ${keysToRemove.length} items from localStorage`);
    console.log('[RESET] Redirecting to homepage...');

    // Perform hard redirect to homepage
    // This ensures a complete app reset with fresh state
    window.location.href = '/';
  }, []);

  return (
    <div className="flex items-center justify-center h-full">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-purple-300 mb-4">Resetting App...</h1>
        <p className="text-gray-400">Clearing data and redirecting to homepage</p>
      </div>
    </div>
  );
}
